import {DEVICEHQ_MAKE_SESSION, DEVICEHQ} from '@/devicehq/api'
// import {DEVICEHQ, TEST_CORS} from '@/devicehq/api'

const getSession = (context, payload) => {
  // console.log(payload)

  // TEST_CORS.post('posts', {
  //   body: JSON.stringify({
  //     title: 'foo',
  //     body: 'bar',
  //     userId: 1,
  //   }),
  // })
  // .then(response => console.log(response))
  // .catch(err => console.log(err))

  // DEVICEHQ.get('/api/v2/info', {
  //   data: {}
  // })
  // .then(response => console.log(response))
  // .catch(err => console.log(err))

  DEVICEHQ_MAKE_SESSION.post(`/api/v2/session?api_key=${payload.api_key}`, {
    data: {},
  })
    .then(response => {
      console.log(response)
      DEVICEHQ.defaults.headers['X-AUTH-TOKEN'] = response.data.meta.token
      context.commit('SESSION_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

export default {
  getSession,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/session/actions.js